import { useState } from "react";
import { Box, IconButton, ImageListItem, ImageListItemBar, Modal, Typography } from "@mui/material";
import { Close as CloseIcon, Delete } from "@mui/icons-material";
import StarIcon from "@mui/icons-material/Star";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import {
  DELETE_POSTS_PICTURES,
  DELETE_PRODUCTS_FAVOURITE_IMAGES,
  GET_POST_COMMENTS,
  POSTS_USER_SETTINGS,
  SAVE_PRODUCTS_FAVOURITE_IMAGES
} from "../../constant/Apipath";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import PostComment  from "../new-community/PostComment";
import { BIRed } from "../../assets/helpers";
import PromptModal from "../common/PromptModal";

const iconButtonOverlayStyle = {
  position: "absolute",
  zIndex: 99,
  backgroundColor: "rgba(0, 0, 0, 0.4)", // dark & transparent
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.6)" // darker on hover
  },
  color: "darkgrey"
};

const ProductPhotosModal = ({ open, onClose, selectedIndex, photos, getUpdatedPhotos, productDetails }) => {
  let { id } = useParams();
  const { loginData, multiLanguageData, selectedLanguage } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [photoList, setPhotoList] = useState([...photos]);
  const [posts, setPosts] = useState(photos || []);
  const [selectedImage, setSelectedImage] = useState(photoList?.[selectedIndex ?? 0]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(selectedIndex ?? 0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openDelImgPrompt, setOpenDelImgPrompt] = useState(false);
  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_COMMENTS = English.Products.TEXT_COMMENTS,
    TEXT_ARE_YOU_SURE_DELETE_IMAGE = English?.Products?.TEXT_ARE_YOU_SURE_DELETE_IMAGE,
    BUTTON_MODAL_DELETE_YES = English?.Products?.BUTTON_MODAL_DELETE_YES,
  } = LanguageData || {};

  const [pageNr, setPageNr] = useState(1);
  const [showComments, setShowComments] = useState(false);
  const [commentList, setCommentList] = useState([]);

  const handlePreviousPhotoClick = () => {
    let index = selectedImageIndex - 1;
    setSelectedImageIndex(index);
    setSelectedImage(photoList?.[index]);
    setShowComments(false);
  };

  const handleNextPhotoClick = () => {
    let index = selectedImageIndex + 1;
    setSelectedImageIndex(index);
    setSelectedImage(photoList?.[index]);
    setShowComments(false);
  };

  const handleMutePost = async (id, isMute) => {
    try {
      const mutePostObj = {
        UserId: currentUserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            PostId: Number(id),
            UserId: currentUserId,
            IsHidden: false,
            IsMute: !isMute
          }
        ]
      };
      let mutePostRes = await Postrequestcall(
        POSTS_USER_SETTINGS,
        mutePostObj,
        loginData?.accessToken
      );
      if (mutePostRes?.data?.message === "OK") {
        const updatedPosts = posts.map((post) => {
          if (post?.id === id) {
            return {
              ...post,
              isMute: !post.isMute // Toggle the isMute key
            };
          }
          return post; // Keep the other posts unchanged
        });
        setPosts(updatedPosts);
      }
    } catch (err) {
      console.log("handleMutePost-> Error While Muting Post: ", err);
    }
  };

  const onStarClick = async (selectedImage, isFavorite) => {
    try {
      setSubmitLoading(true);
      let obj = {};
      let apiUrl = "";
      if (isFavorite) {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: [
            {
              ProductPictureId: selectedImage?.pictureId,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        apiUrl = DELETE_PRODUCTS_FAVOURITE_IMAGES;
      } else {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              ProductId: id,
              ProductPictureId: selectedImage?.pictureId,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        apiUrl = SAVE_PRODUCTS_FAVOURITE_IMAGES;
      }
      await Postrequestcall(apiUrl, obj, loginData?.accessToken);
      let updatedPhotosList = [
        ...photoList.map((item) => {
          if (item?.id === selectedImage?.id && item?.pictureId === selectedImage?.pictureId) {
            return { ...item, isFavorite: !item?.isFavorite };
          } else {
            return item;
          }
        })
      ];
      setPhotoList(updatedPhotosList);
      setSelectedImage(updatedPhotosList?.[selectedImageIndex]);
      setSubmitLoading(false);
      onClose();
      await getUpdatedPhotos();
    } catch (error) {
      setSubmitLoading(false);
      console.log("onStarClick-> Error While Updating Photos: ", error);
    }
  };

  const getPostComment = async () => {
    let res = await Getrequestcall(
      `${GET_POST_COMMENTS}/${currentUserId}/${selectedImage?.id}/${pageNr}/20/${selectedImage?.appId}/${selectedLanguage}`,
      loginData?.accessToken
    );
    let resData = res?.data?.data ?? [];
    setCommentList(resData?.reverse());
  };

  const onCommentClick = (showComments) => {
    setShowComments((preValue) => !preValue);
    if (!showComments) {
      getPostComment();
    }
  };

  const handleDeleteImage = async () => {
    const obj = {
      UserId: currentUserId,
      ReturnRecordId: false,
      ReturnRecordError: true,
      DeleteList: [
        {
          Id: selectedImage?.pictureId,
          ModifiedBy: currentUserId
        }
      ]
    }
    const res = await Postrequestcall(DELETE_POSTS_PICTURES, obj, loginData?.accessToken);
    if (res?.status === 201) {
      setOpenDelImgPrompt(false);
      onClose();
      getUpdatedPhotos();
    }
  }

  function getPictureUrl(item) {
    if (item == null) {
      return null;
    } else if (item == "") {
      return null;
    } else {
      return item;
    }
  }

  const handleCommentPost = async () => {
    let updatedPhotosList = [
      ...photoList.map((item) => {
        if (item?.id === selectedImage?.id && item?.pictureId === selectedImage?.pictureId) {
          return { ...item, nrComments: item?.nrComments + 1 };
        } else {
          return item;
        }
      })
    ];
    setPhotoList(updatedPhotosList);
    setSelectedImage(updatedPhotosList?.[selectedImageIndex]);
    setShowComments(false);
  };

  // Determine if the current user can delete the selected photo
  const canDeletePhoto = () => {
    // For unverified products, everyone can delete
    if (!productDetails?.verified) {
      return true;
    }
    // For verified products, only product creator or photo uploader can delete
    const isProductCreator = currentUserId === productDetails?.createdBy;
    const isPhotoUploader = currentUserId === selectedImage?.postedByUserId;

    return isProductCreator || isPhotoUploader;
  };

  return (
    <>
      {showComments && (
        <PostComment
          posts={posts}
          setPosts={setPosts}
          pageName={"Product Post"}
          handleMutePost={handleMutePost}
          handleCommentPost={handleCommentPost}
          postItem={{
            id: selectedImage?.id,
            formatTypeId: selectedImage?.formatTypeId,
            appId: selectedImage?.appId,
            pictureList: [selectedImage]
          }}
          open={showComments}
          onClose={() => setShowComments(false)}
          from={"Product Photos"}
        />
      )}

      <Modal open={open}>
        <Box className="user-modal-responsive">
          <ImageListItem key={selectedImage?.pictureUrl}>
            <IconButton
              onClick={async () => {
                onClose();
                // await getUpdatedPhotos();
              }}
              size="small"
              sx={{
                ...iconButtonOverlayStyle,
                top: "4%",
                left: "2%",
                color: 'white'
              }}>
              <CloseIcon />
            </IconButton>
            {canDeletePhoto() && (
              <IconButton
                onClick={() => setOpenDelImgPrompt(true)}
                size="small"
                sx={{
                  position: "absolute",
                  zIndex: 99,
                  top: { xs: "4%", sm: "4%", md: "4%" },
                  right: { xs: "18%", sm: "10%", md: "9%" },
                  background: BIRed,
                  "&:hover": {
                    backgroundColor: BIRed,
                  },
                }}>
                <Delete sx={{ color: 'white' }} />
              </IconButton>
            )}
            <IconButton
              loading={submitLoading}
              onClick={() => onStarClick(selectedImage, selectedImage?.isFavorite)}
              size="small"
              sx={{
                ...iconButtonOverlayStyle,
                top: "4%",
                right: "2%",
              }}>
              <StarIcon sx={{ color: selectedImage?.isFavorite ? "gold" : "darkgray" }} />
            </IconButton>

            {selectedImageIndex !== 0 && (
              <IconButton
                onClick={handlePreviousPhotoClick}
                size="small"
                sx={{
                  ...iconButtonOverlayStyle,
                  top: "40%",
                  left: "2%",
                  color: 'white'
                }}>
                <SkipPreviousIcon />
              </IconButton>
            )}
            {selectedImageIndex !== photos?.length - 1 && (
              <IconButton
                onClick={handleNextPhotoClick}
                size="small"
                sx={{
                  ...iconButtonOverlayStyle,
                  top: "40%",
                  right: "2%",
                  color: 'white'
                }}>
                <SkipNextIcon />
              </IconButton>
            )}

            <img
              style={{ height: "400px", objectFit: "contain", position: "relative" }}
              src={`${selectedImage?.pictureUrl}`}
              alt={"picture"}
              loading="lazy"
            />
            <ImageListItemBar
              title={
                <Typography variant="body1">{`${selectedImage.postedByFirstName} ${selectedImage.postedByLastName} (${selectedImage.tradeName})`}</Typography>
              }
              subtitle={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}>
                  <Typography variant="body2">
                    Photo taken:{" "}
                    {selectedImage.pictureDateTime != null ? selectedImage.pictureDateTime : "N/A"}
                  </Typography>

                  <Box
                    sx={{ flexDirection: "row",  alignItems: "center",  display: "flex" }}
                    
                    
                    style={{ cursor: "pointer" }}
                    onClick={() => onCommentClick(showComments)}>
                    <Typography sx={{ pr: 0.5 }}>
                      {selectedImage?.nrComments || 0} {TEXT_COMMENTS}
                    </Typography>
                  </Box>
                </Box>
              }
              position="below"
            />
          </ImageListItem>
        </Box>
      </Modal>
      {
        openDelImgPrompt &&
        <PromptModal
          isOpen={openDelImgPrompt}
          onClose={() => setOpenDelImgPrompt(false)}
          desc={TEXT_ARE_YOU_SURE_DELETE_IMAGE}
          redButtonText={BUTTON_MODAL_DELETE_YES}
          onRedButtonClick={handleDeleteImage}
        />
      }
    </>
  );
};

export default ProductPhotosModal;
